import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { submitSupplementBEntry, SupplementBRequest } from 'api/user'

export function useSubmitSupplementBMutation(
  userId: string,
  options?: UseMutationOptions<unknown, Error, SupplementBRequest, unknown>
) {
  return useMutation({
    mutationFn: (payload) => submitSupplementBEntry(userId, payload),
    ...options,
  })
}
